"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.biErrorLogger = void 0;
var create_logger_1 = require("./create-logger");
exports.biErrorLogger = create_logger_1.createBiLogger({
    src: 94,
    evid: 837,
});
//# sourceMappingURL=bi-error-logger.js.map